export default "__VITE_ASSET__bb898fae__"